/**
 * Sign-in screen. A valuer's whole journey is: sign in -> upload. Nothing else here.
 */
import { useState } from 'react';
import type { FormEvent } from 'react';
import { useAuth } from '../auth';
import { Button, Tile, Banner } from '../components/ui';

export function Login() {
  const { signIn } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await signIn(email.trim(), password);
    } catch {
      setError('Those sign-in details don’t match. Please check your email and password.');
      setBusy(false);
    }
  };

  return (
    <div className="login-wrap">
      <Tile className="login-card tile--pad-lg">
        <h1 className="login-title">Valuation QA</h1>
        <p className="login-sub">Sign in to upload a report.</p>
        <form className="stack" onSubmit={onSubmit} noValidate>
          {error ? <Banner tone="error">{error}</Banner> : null}
          <div className="field">
            <label className="field__label" htmlFor="email">
              Email
            </label>
            <input
              id="email"
              className="input"
              type="email"
              autoComplete="email"
              autoCapitalize="none"
              spellCheck={false}
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="field">
            <label className="field__label" htmlFor="password">
              Password
            </label>
            <input
              id="password"
              className="input"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <Button type="submit" block disabled={busy || !email || !password}>
            {busy ? 'Signing in…' : 'Sign in'}
          </Button>
        </form>
      </Tile>
    </div>
  );
}
